import React from 'react';
import {View} from 'react-native';
import CCText from '@/Atoms/CCText';
import {Medal, lbColors} from '../leaderboardTheme';

interface Props {
  rank: number;
  medal: Medal | null;
  size?: number;
}

/** Rank number; gold/silver/bronze chip for the top three. */
export default function RankBadge({rank, medal, size = 26}: Props) {
  return (
    <View
      style={{
        minWidth: size,
        paddingVertical: 3,
        paddingHorizontal: 4,
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: medal ? medal.bg : 'transparent',
      }}>
      <CCText
        fontSize={13}
        fontWeight="bold"
        color={medal ? medal.tx : lbColors.muted}>
        {rank}
      </CCText>
    </View>
  );
}
